import React, { useState } from 'react';
const AccordionMini = (props) => {
    const [expanded, setExpanded] = useState(props.initialOpen);
    return (React.createElement("div", { className: "accordion-mini" },
        React.createElement("button", { type: "button", className: "accordion-mini__header", "aria-expanded": expanded, "aria-controls": props.id, onClick: () => {
                let newvalue = !expanded;
                setExpanded(newvalue);
                props.onExpand && props.onExpand(newvalue);
            } }, props.title),
        React.createElement("div", { id: props.id, className: "accordion-mini__panel" }, props.children)));
};
AccordionMini.defaultProps = {
    initialOpen: false,
};
export default AccordionMini;
